import { cn } from '@seen/ui'
import { IconGripVertical } from '@tabler/icons-react'
import type { ComponentProps, JSX } from 'react'
import { PanelResizeHandle } from 'react-resizable-panels'

export function ResizableHandle({
  withHandle,
  className,
  ...props
}: ComponentProps<typeof PanelResizeHandle> & {
  withHandle?: boolean
}): JSX.Element {
  return (
    <PanelResizeHandle
      className={cn(
        'after:-translate-x-1/2 data-[panel-group-direction=vertical]:after:-translate-y-1/2 relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-zinc-950 focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:translate-x-0 dark:focus-visible:ring-zinc-300 [&[data-panel-group-direction=vertical]>div]:rotate-90',
        className
      )}
      {...props}
    >
      {withHandle && (
        <div className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border-border bg-border">
          <IconGripVertical className="size-2.5" />
        </div>
      )}
    </PanelResizeHandle>
  )
}
